export default __webpack_public_path__ + "static/media/yoga.1462a2aa.svg";